import getAuthToken from "./getAuthToken";

const getOfferId = (): string => {
    return getAuthToken().split('-')[1] || '';
}
export default getOfferId;